var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-tag',{attrs:{"clickable":_vm.clickable},on:{"close":function($event){return _vm.$emit('delete', _vm.user.id)}}},[_vm._v(_vm._s(_vm.user.fullName))])}
var staticRenderFns = []

export { render, staticRenderFns }